<div>
  <p-card [header]="'Summerat'" class="summary">
    <div class="label-value label-value-nb">
      <div>Totala beräknade intäkter</div>
      <div>{{ totalExpectedRevenue | currency: 'SEK' }}</div>
    </div>
    <div *ngIf="totalAtaSum !== 0" class="label-value label-value-sub">
      <div>varav ÄTA</div>
      <div>{{ totalAtaSum | currency: 'SEK' }}</div>
    </div>
    <div
      *ngIf="totalAtaSum === 0 && totalExtraSum !== 0"
      class="label-value label-value-sub"
    >
      <div>varav extra</div>
      <div>{{ totalExtraSum | currency: 'SEK' }}</div>
    </div>
    <div class="label-value">
      <div>Totala kostnader</div>
      <div>{{ totalCost | currency: 'SEK' }}</div>
    </div>
    <div class="label-value">
      <div>Totala timmar</div>
      <div>{{ totalHours }} h</div>
    </div>
    <div *ngIf="setMile" class="label-value">
      <div>Totala mil</div>
      <div>{{ totalMilage }} mil</div>
    </div>
  </p-card>

  <p-card class="result-progress">
    <div class="label-value">
      <div>Totalt fakturerat</div>
      <div>{{ totalInvoiceSum | currency: 'SEK' }}</div>
    </div>
    <div class="label-value">
      <div>Återstående fakturering</div>
      <div>{{ totalInvoiceSumLeft | currency: 'SEK' }}</div>
    </div>
    <div class="label-value">
      <div>Nuvarande resultat:</div>
      <div>
        {{ currentResult | currency: 'SEK' }}
        <span title="Täckningsgrad">({{ currentCoverage | percent }})</span>
      </div>
    </div>
    <div class="label-value">
      <div>Förväntat resultat:</div>
      <div>
        {{ expectedResult | currency: 'SEK' }}
        <span title="Täckningsgrad">({{ expectedCoverage | percent }})</span>
      </div>
    </div>
  </p-card>
  <p-card *ngIf="isAdmin" class="overhead-settings">
    <div class="overhead-title">Omkostnader</div>
    <div class="overhead-controls">
      <p-inputNumber
        [ngModel]="overheadCalculationValue"
        (ngModelChange)="onOverheadValueChanged($event)"
        [min]="0"
        [max]="overheadCalculationMode === 1 ? 100 : null"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        [disabled]="overheadSaving"
      ></p-inputNumber>
      <p-selectButton
        [options]="overheadModes"
        [ngModel]="overheadCalculationMode"
        (ngModelChange)="onOverheadModeChanged($event)"
        [disabled]="overheadSaving"
      ></p-selectButton>
      <button
        pButton
        type="button"
        class="p-button-primary-hyperion"
        label="Spara"
        [disabled]="overheadSaving || overheadValueIsInvalid"
        (click)="saveOverhead()"
      ></button>
    </div>
  </p-card>
  <p-card class="date-select">
    <div
      class="overview-option cost-calculation"
      *ngIf="
        companyFunctionService.hasCompanyFunction('useUserCostType') | async
      "
    >
      <span class="option-label">
        <span>Kostnadsberäkning för arbetstid</span>
        <i
          pTooltip="Välj Lönebaserad om kostnaderna för arbetstid ska baseras på era anställdas lön. Välj Yrkestyp om du vill använda internkostnaden för yrkestyper."
          class="pi pi-info-circle"
        ></i>
      </span>
      <p-selectButton
        [options]="[
          { label: 'Lönebaserad', value: 0 },
          { label: 'Yrkestyp', value: 1 }
        ]"
        [(ngModel)]="projectOverviewService.costCalculationMode"
      ></p-selectButton>
    </div>
    <div class="overview-option subproject-option" *ngIf="showSubProjectToggle">
      <span>Inkludera underprojekt i summeringen</span>
      <p-selectButton
        [options]="[
          { label: 'Ja', value: true },
          { label: 'Nej', value: false }
        ]"
        [(ngModel)]="includeSubProjects"
        (ngModelChange)="onIncludeSubProjectsChanged($event)"
      ></p-selectButton>
    </div>
    <div class="date-controls">
      <div class="p-grid p-p-0">
        <span class="p-col-6 p-pb-0 p-pt-0 p-pl-0">
          <label>Från</label>
          <p-calendar
            firstDayOfWeek="1"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [(ngModel)]="timeSpan.startDate"
            (onClose)="onTimeSpanChanged()"
            [showWeek]="true"
          ></p-calendar>
        </span>
        <span class="p-col-6 p-p-0">
          <label>Till</label>
          <p-calendar
            firstDayOfWeek="1"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [(ngModel)]="timeSpan.endDate"
            (onClose)="onTimeSpanChanged()"
            [showWeek]="true"
          ></p-calendar>
        </span>
        <button
          pButton
          class="p-button-primary-hyperion p-col-12 p-mt-3"
          [icon]="excelLoading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
          label="Exportera till Excel"
          (click)="exportToExcel()"
          [disabled]="excelLoading"
        ></button>
      </div>
    </div>
  </p-card>
</div>
